import { render } from "./saleleger.vue?vue&type=template&id=2915cede"
import script from "./saleleger.vue?vue&type=script&lang=js"
export * from "./saleleger.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__